var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"centered":"","id":"dlgIframe","title":_vm.title,"hide-footer":"","size":"lg","height":"80%"},model:{value:(_vm.apriDialogIframe),callback:function ($$v) {_vm.apriDialogIframe=$$v},expression:"apriDialogIframe"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.HtmlContents)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }